import React, { forwardRef, useMemo } from "react";
import "../NavbarV3.css";
import { NavbarRightItems } from "./constants/Dropdown.constants.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import {
  ConfigItemsEnum,
  NavbarRightItemsEnum,
} from "./interfaces/Dropdown.enum.ts";
import DropdownSection from "./components/DropdownSection.tsx";

interface DropdownConfigProps {
  ref: React.RefObject<HTMLDivElement>;
}

const DropdownConfig = forwardRef<HTMLDivElement, DropdownConfigProps>(
  (props, ref) => {
    const configSection =
      NavbarRightItems[NavbarRightItemsEnum.CONFIG].sections;

    const memorizedConfigItems = useMemo(() => {
      return configSection[ConfigItemsEnum.CONFIG].items.map((item) => (
        <RotaItem key={`config-${item.rota}`} item={item} />
      ));
    }, [configSection]);

    return (
      <div className="dropdown-content-config" ref={ref}>
        <div className="separador-menu-configuracao" />
        <div className="content-menu-rows">
          <DropdownSection
            titleSection={configSection[ConfigItemsEnum.CONFIG].titleSection}
            icon={configSection[ConfigItemsEnum.CONFIG].icon}
            children={memorizedConfigItems}
          />
        </div>
      </div>
    );
  }
);

export default DropdownConfig;
